export const state = {
    accessibility: {
        enabled: false,
        options: {
            fontSize: '1em',
            speak: true
        },
        selections: null,
        newSearch: false,
    }
};

export default state;
